import ComponentLayout from "../../../../src/layouts/component-layout";
import { PropTableValues } from "../../../../src/components";
import { SectionBackgroundColors, SectionPaddingVariants } from '@primer/react-brand';
import * as React from 'react';
export default {
  ComponentLayout,
  PropTableValues,
  SectionBackgroundColors,
  SectionPaddingVariants,
  React
};